import React, { useEffect, useState } from 'react';
import { usePrematchData } from '../../prematch/PrematchDataFetcher';
import SearchDataFetcher from './SearchDataFetcher';
import { filterSportsFromSearchResults, iconSportCssClass } from '../../data/utils';
import { navigate } from '../../router/Link';
import { prematchPrefix } from '../../Container';
import { getLabel } from '../../InitData';
import InfoMessage from '../InfoMessage';

export default function SearchResults(props) {
    // const searchData = useSearchData();
    const prematchData = usePrematchData();
    
    const [search, setSearch] = useState(null);

    function handleClick(e, event) {
        e.stopPropagation();
        navigate(`${prematchPrefix}/${event.urlPath}`);
        setSearch('');
        window.dispatchEvent(new CustomEvent('xs_openEvent', {detail: event}));
    }

    useEffect(() => {
        function listener(e) {
            setSearch(e.detail);
        }

        window.addEventListener('xs_search', listener);
        return () => window.removeEventListener('xs_search', listener);
    }, []);

    if (search == null || search.length <= 3) {
        return null;
    }

    return (
        <SearchDataFetcher renderItem={(data) => {
            const sports = filterSportsFromSearchResults(data, search);
        
            if (sports.length === 0) {
                return (
                    <div className="c_35">
                        <InfoMessage text={getLabel('general.no_results')} />
                    </div>
                );
            }
        
            // Sort sports by ranking
            try {
                sports.sort((a, b) => {
                    const rankingA = prematchData.sportById[a.id].ranking;
                    const rankingB = prematchData.sportById[b.id].ranking;
                    return rankingA - rankingB;
                });
            } catch(e) {
                console.error(e);
            }

            let count = 0;
            const events = [];
            sports.forEach(s =>
                s.tournaments.forEach(t => {
                    const event = t.events[0];
                    const sport = prematchData.sportById[event.sportRef];
                    const sportIcon = iconSportCssClass(sport.id, sport.iconClass);

                    count += t.events.length;
                    t.events.forEach(e =>
                        events.push(
                            <div key={e.uniqueId} className="c_35_2" onClick={(e) => handleClick(e, event)}>
                                <div className="c_35_2_1">
                                    <div className="c_35_2_1_1">
                                        <div className={"c_35_2_1_1_1 " + sportIcon}></div>
                                        <div className="c_35_2_1_1_2">{`${e.sportDesc} | ${e.categoryDesc} | ${t.desc}`}</div>
                                    </div>
                                </div>
                                <div className="c_35_2_2">{e.desc}</div>
                            </div>
                        )
                    )
                })
            );

            return (
                <div className="c_35">
                    <div className="c_35_1">{getLabel('general.find')} ({count})</div>
                    {events}
                </div>
            );
        }} />
    );
}
